import { render, staticRenderFns } from "./SendJoinInvitesModal.vue?vue&type=template&id=a6a59610"
import script from "./SendJoinInvitesModal.vue?vue&type=script&lang=js"
export * from "./SendJoinInvitesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports